var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, makeObservable, observable, reaction, runInAction } from 'mobx';
import { MandateType } from '../../config/mandate';
import API from '../../util/ApiUtil';
export default class PartyPrivacyProfileStore {
    constructor(rootStore) {
        Object.defineProperty(this, "profileResource", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                partyPrivacyProfile: null,
                partyPrivacyProfileSpecification: null
            }
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'UNINITIALIZED'
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mandateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fetchPartyPrivacyProfileResource", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async () => {
                this.setStatus('FETCHING');
                try {
                    const response = await API.get('/profile');
                    runInAction(() => {
                        this.profileResource = response.data;
                        this.setStatus('FETCHED');
                    });
                }
                catch (e) {
                    this.setStatus('ERROR');
                    console.error(e);
                }
            }
        });
        Object.defineProperty(this, "shouldFetchPartyPrivacyProfileResource", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return ['UNINITIALIZED', 'ERROR'].includes(this.status);
            }
        });
        makeObservable(this);
        this.ssoStore = rootStore.ssoStore;
        this.mandateStore = rootStore.mandateStore;
        reaction(() => this.ssoStore.customerId, () => this.handleCustomerChange());
    }
    get profilesWithSpecLoaded() {
        return this.status === 'FETCHED';
    }
    isFetching() {
        return ['UNINITIALIZED', 'FETCHING'].includes(this.status);
    }
    get hasProfile() {
        return this.profileResource.partyPrivacyProfile !== null;
    }
    get getAgreements() {
        return this.hasProfile
            ? this.profileResource.partyPrivacyProfile.partyPrivacyAgreements
            : this.profileResource.partyPrivacyProfileSpecification.specificationCharacteristics.map((characteristic) => ({
                id: characteristic.id,
                agreementType: characteristic.name,
                agreementGiven: null
            }));
    }
    get shouldUserRefreshAgreements() {
        const isFetching = this.mandateStore.isFetching(MandateType.SERVICE) || this.mandateStore.isFetching(MandateType.LEGAL) || this.isFetching();
        if (isFetching) {
            return false;
        }
        return !this.hasProfile;
    }
    async loadPartyPrivacyProfileResource(forceFetch = false) {
        const shouldFetch = !!this.ssoStore.auth && (forceFetch || this.shouldFetchPartyPrivacyProfileResource());
        if (shouldFetch) {
            return this.fetchPartyPrivacyProfileResource();
        }
        return Promise.resolve();
    }
    setStatus(status) {
        this.status = status;
    }
    handleCustomerChange() {
        this.setStatus('UNINITIALIZED');
    }
}
__decorate([
    observable
], PartyPrivacyProfileStore.prototype, "profileResource", void 0);
__decorate([
    observable
], PartyPrivacyProfileStore.prototype, "status", void 0);
__decorate([
    computed
], PartyPrivacyProfileStore.prototype, "profilesWithSpecLoaded", null);
__decorate([
    computed
], PartyPrivacyProfileStore.prototype, "hasProfile", null);
__decorate([
    computed
], PartyPrivacyProfileStore.prototype, "getAgreements", null);
__decorate([
    computed
], PartyPrivacyProfileStore.prototype, "shouldUserRefreshAgreements", null);
__decorate([
    action.bound
], PartyPrivacyProfileStore.prototype, "loadPartyPrivacyProfileResource", null);
__decorate([
    action.bound
], PartyPrivacyProfileStore.prototype, "setStatus", null);
